import FullLayout from '@/modules/core/layouts/FullLayout.vue';
import ViewVision from './ViewVision.vue';
import AddAssinatura from './AddAssinatura.vue';

export default {
  path: '/admin',
  component: FullLayout,
  meta: { requiresAuth: true },
  children: [
    { name: 'assinatura', path: 'assinaturas', component: ViewVision },
    { name: 'criarAssinatura', path: 'assinaturas/0', component: AddAssinatura },
  ],
};
